export default __webpack_public_path__ + "files/BIOE7.pdf";